import Configloader from './Configloader';

export {
  Configloader
};


// WEBPACK FOOTER //
// ./src/util/loader/index.js